<template>
  <div class="xieyi">
    <h2>用户协议</h2>
    <p>
      本协议系由您（或称“用户”）与东莞万饰网络科技有限公司（或称“我们”）就使用东莞市五金饰品行业协会平台以及其他我们开发的小程序服务（以下简称“平台”）共同签署本《用户协议》（以下简称“本协议”）。
    </p>
    <p>
      在您使用本平台服务前，为维护您自身权益，请您务必审慎阅读、充分理解本协议各项条款（如果您未满16周岁，或已满16周岁未满18周岁且不能以自己的劳动收入作为主要收入来源的，请在法定监护人的陪同下阅读本协议），以及其它以加粗加黑的显示形式提示您注意的重要条款，请务必重点查阅。
    </p>
    <p>
      【审慎阅读】您在注册、创建店铺流程中点击同意本协议之前，应当认真阅读本协议的全部内容（特别是免除或者限制责任的条款、协议终止、违约责任、争议解决等以粗体下划线标注的条款）。如果您对本协议有任何的疑问、投诉、意见和建议，欢迎您与我们沟通反馈，我们十分乐意为您解答。
    </p>
    <p>
      【签约动作】当您在线点击签署本协议，即表示您已充分阅读、理解并接受本协议的全部内容，本协议即产生法律约束力。如您不同意本协议的任何内容或无法准确理解条款含义及解释，您有充分且完全的权利退出使用本平台服务。
    </p>
    <p>一、协议、服务范围及平台更新</p>
    <p>
      1.1【协议范围】本协议适用于本平台内用户的注册及管理，为了更全面的界定各方之间的权利义务，本协议包括我们根据法律法规之规定以及本协议制定的其他政策、规则、公告声明等（除非特有所指，合称为“本协议”），您也应当加以遵守，如您使用本平台服务，视为您同意本协议所有内容，除另行声明或签署协议外，我们基于任何提升卖家体验、消费者体验、平台服务升级等目的所扩大的服务范围或小程序功能的增强均受本协议的约束。
    </p>
    <p>
      1.2【服务范围】我们可能通过不断丰富的功能界面向您提供本协议项下的平台服务，包括但不限于小程序、应用程序（“APP”）、PC端网站以及其他形式，具体以我们实时发布的服务功能界面范围为准。
    </p>
    <p>
      1.3【平台更新】您同意并知悉，平台中的具体内容、功能和形式由平台根据实际情况按“现状”实时提供，我们有权自行确定平台服务的具体内容、功能和形式，有权自行决定增加、变更、中断和停止平台具体的内容、功能和形式。具体以平台实时呈现的服务内容、功能和形式为准。
    </p>
    <p>二、用户账号使用规则</p>
    <p>
      2.1【账户注册】您可以按照平台注册页面提示填写信息，通过注册平台帐号进行登录，您知悉并理解，在您注册、登录平台后，我们会为您配置生成您在平台帐号，并同时为您生成东莞万饰网络科技有限公司名下其他程序的平台账号，实现用户数据互通，为您配置的帐号之所有权归我们所有，您在本协议有效期内仅享有使用权。同时，平台也支持使用第三方帐号（如微信帐号）进行登录的功能，我们将会通过小程序界面的跳转以实现获得您本人对通过第三方帐号登陆的授权，您也可以随时在第三方平台进行操作，取消对我们的登录授权。
    </p>
    <p>
      2.2【账户使用】您应对您账户项下的所有行为结果（如在线签署协议、发布及披露信息等）负责，通过您账户完成的行为均视为您本人行为或已获得您充分授权。如我们根据本协议中约定判断您账户的使用可能危及您的账户安全或平台信息安全的，我们可拒绝提供相应服务或终止本协议。
    </p>
    <p>
      2.3【账户注销】如果您需要注销您的帐号，您可以联系我们的客服进行操作，我们将在核实您的身份并清理帐号资产（例如账户金额、红包、优惠券等）并确认无纠纷争议后，提供帐号注销服务。在注销帐号之后本协议即终止，我们将停止为您提供任何服务，您无法通过该帐号登陆和使用本平台服务，和帐号关联的相关虚拟权益（包括但不限于用户身份资格、虚拟积分、优惠券等全部权益）亦永久消除。
    </p>
    <p>
      2.4【账户安全保障责任】我们将根据法律法规的规定为您提供帐号安全保障责任，您亦有责任自行负责保管帐号的用户名和密码等信息，若您的帐号可能导致账户遭窃、遗失的情况，您需要立即通知我们，否则因该等事项引发的法律责任由您自行承担。凡使用本平台服务登录帐号和登录凭证的行为，视为您本人的操作，操作所产生的电子信息记录均为平台服务用户行为的有效凭据。未经我们同意，您的帐号仅供您本人使用，帐号信息和权限不得以转让、赠与、借用、售卖、授权或租用等方式许可给第三方使用或和第三方共同控制、使用。
    </p>
    <p>三、用户权利及用户规范</p>
    <p>3.1 权利内容：</p>
    <p>
      3.1.1【店铺创建】在您使用本平台的过程中，我们为您提供了店铺创建、发布产品的供应和求购信息、享用平台提供的市场行情关键词检索、主动推送商品信息流等功能，以便更好地匹配您的运营店铺、采购、交易等需求。
    </p>
    <p>
      3.1.2【订单管理】在您登录本平台后，您可通过平台便捷地进行交易订单的管理，查看您的订单的状态、售后情况等，还可以自由浏览、查找并选购平台所展示的商品或服务。此外，您可以参加本平台或第三方商家组织的各类促销等活动，享受相关信息及技术服务。
    </p>
    <p>
      3.1.3【第三方支付】为交易达成以及提升用户体验等目的，本平台亦将为您提供更为友好完善的交易规则服务，优化和引入第三方支付（通联支付）服务。您使用本平台的支付功能即表示您同意且使用通联支付相关服务，我们会将您的支付信息（包括但不限于微信UID、手机号码等）传送给通联支付公司，以确保您成为通联支付的用户及在本平台进行支付。通联支付的使用费率将在您开通收款账户时通过平台公告、协议或其他书面方式详细说明。若通联支付调整服务费费率或结算方式，我们将在平台上对调整后的服务费费率或结算方式进行公布，自公布之日起适用新的服务费费率/结算方式。
    </p>
    <p>
      3.1.4【信息共享】您可根据自身所需，通过平台资源库寻找合适的品牌连锁店、贸易公司、电商公司、成品厂、加工厂等进行采购，并可通过平台发布需求，以获得供应商资源等。
    </p>
    <p>
      3.1.5【月结功能】您可根据自身所需，对您的客户开通月结功能。本平台提供的月结功能仅为您提供记账、账期提醒功能。若您使用本平台月结功能，视为您已悉知并同意月结功能属于您与客户之间的个人行为，在月结付款时款项既不经过平台也不经过本平台使用的第三方支付，平台也不以此为盈利，当发生款项无法收回时，与平台无关。
    </p>
    <p>3.2用户规范：</p>
    <p>
      3.2.1
      【行为禁止】您可在本协议约定的范围内使用本平台服务，您不得利用本平台从事以下行为：
    </p>
    <p>（1）超出授权或恶意使用本平台服务；</p>
    <p>
      （2）利用本平台发表、传送、传播、储存危害国家安全、国家统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容，或者设置含有上述内容的网名、角色名，发布、传送、传播违法广告信息、营销信息及垃圾信息等；
    </p>
    <p>
      （3）利用本平台侵害他人知识产权、肖像权、隐私权、名誉权、个人信息等合法权利或权益；
    </p>
    <p>（4）恶意虚构或协助虚构事实、评价等信息或数据；</p>
    <p>
      （5）进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器或账户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；利用平台及服务上传任何病毒、木马，或者蠕虫等危害网络健康的内容；
    </p>
    <p>
      （6）对平台进行反向工程、反向编译或反向汇编或以其它方式企图发现平台的源代码和算法，未经许可修改、禁用平台小程序的任何功能或创建衍生作品。去除平台或文档上的任何所有权声明或标签，或将其他小程序、软件与平台合并；
    </p>
    <p>
      （7）从事其他法律法规、政策及公序良俗、社会公德禁止的行为以及侵犯其他个人、公司、社会团体、组织的合法权益的行为。
    </p>
    <p>
      3.2.2【禁止性信息】
      您使用本平台服务时，禁止制作、复制、发布含有下列内容的不良信息：
    </p>
    <p>（1）使用夸张标题，内容与标题严重不符的；</p>
    <p>（2）炒作绯闻、丑闻、劣迹等的；</p>
    <p>（3）不当评述自然灾害、重大事故等灾难的；</p>
    <p>（4）带有性暗示、性挑逗等易使人产生性联想的；</p>
    <p>（5）展现血腥、惊悚、残忍等致人身心不适的；</p>
    <p>（6）煽动人群歧视、地域歧视等的；</p>
    <p>（7）宣扬低俗、庸俗、媚俗内容的；</p>
    <p>
      （8）可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；
    </p>
    <p>（9）其他对网络生态造成不良影响的内容。</p>
    <p>
      3.2.3【授权第三方】未经我们书面许可，您不得自行或授权、允许、协助任何第三人对本平台中信息内容进行如下行为：
    </p>
    <p>（1）复制、读取、采用本平台的信息内容，用于任何形式的商业用途；</p>
    <p>
      （2）擅自编辑、整理、编排平台及相关服务的信息内容后在本平台及相关服务的源页面以外的渠道进行展示；
    </p>
    <p>
      （3）采用不正当方式，自行或协助第三人对本平台及相关服务的信息内容产生流量、阅读量或交易引导、转移、劫持等不利影响。
    </p>
    <p>（四）其他不适合在平台上销售或提供的。</p>
    <p>
      3.2.4【资料真实性】您应对本平台提供的证件、签名、印鉴、文件等各种资料的真实性、合法性、有效性承担相应法律后果；如有变更，应及时联系本平台客服进行修改，并承担因未及时通知本平台作相应变更而导致的法律后果。
    </p>
    <p>四、费用</p>
    <p>
      4.1
      您使用本平台的基础功能无需支付费用（比如注册登录、发布需求、与其他用户联系、评价等功能），如未来我们想您收取其他相关费用，我们会采取合理途径并以足够合理的期限提前进行通知。
    </p>
    <p>五、信息或广告推送</p>
    <p>
      5.1
      您同意在接受我们提供服务的同时，允许我们在遵守法律法规的前提下自行或由第三方广告商向您发送、展示广告、推广或宣传信息（包括商业与非商业信息）。如您对发送、推荐的广告或信息不感兴趣，您可以基于我们提供的相关技术选项，控制系统向您展示、不展示或减少展示相关类型的广告或信息。
    </p>
    <p>六、知识产权等权益</p>
    <p>
      6.1
      您在使用我们平台服务时利用产品及服务所发表上传的文字、图片、视频、软件等原创信息的知识产权归您所有（或由第三方内容提供方和您另行约定），但是基于产品运营的需求，您确认您对该等信息的发表、上传行为视同为对我们授权知识产权的使用、复制、传播等权利。
    </p>
    <p>
      6.2
      基于对数据的合法加工而获得的具有竞争性的数据权益，除法律法规另有规定外，我们享有独立的使用权益而无须获得您的同意。
    </p>
    <p>
      6.3
      关于信息内容的投诉或举报。若您在使用产品过程中，不慎受到合法权益的侵犯，您有权通知我们采取必要措施进行处置。若您在使用产品过程中，发现存在违法违规或违反本服务相关规则的情况，您也有权向我们发起举报，我们亦会及时采取必要措施（删除、屏蔽、断开链接或限制使用功能等）进行处置。
    </p>
    <p>
      6.4
      在法律法规允许的范围内，您同意并授权我们就侵犯您合法权益的行为（包括但不限于私自复制、使用、编辑、抄袭等行为）采取任何形式的法律行动，包括但不限于投诉、诉讼等必要的维权措施。
    </p>
    <p>七、免责条款</p>
    <p>
      7.1
      我们将依照法律规定履行基础保障义务，但对于下述原因导致的履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我们并不承担相应的违约责任：
    </p>
    <p>
      7.1.1 因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
    </p>
    <p>7.1.2 因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</p>
    <p>
      7.1.3
      在平台已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
    </p>
    <p>
      7.2
      鉴于平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，平台无需对所有的交易行为以及与交易相关的其他事项进行事先审查，但是若经消费者、监管部门、权利人等第三方通知平台，或平台基于对商品、交易或店铺等数据分析发现卖家、商品或信息等存在商品质量问题、知识产权侵权、交易欺诈等违法或不当行为，可能涉嫌违反相关法律法律法规及本协议的，您同意平台可根据不同情况向您发出询问或要求改正的通知，或直接作出删除相关信息、对店铺采取限制性措施或停止服务等处理方式。除平台存在故意或重大过失外，我们对上述判断处理免责。
    </p>
    <p>
      7.3
      我们对于您自平台获得的所有他人、第三方消息、内容或广告宣传等任何资讯（以下简称“信息”），除法律明确规定外，不保证真实、准确和完整性。如果任何单位或者个人通过上述信息而进行任何行为，须您自行甄别真伪和谨慎预防风险，在任何情况下，我们不对非因我们直接发生的交易或行为承担任何直接、间接、附带或衍生的损失和责任。
    </p>
    <p>八、用户违约责任及处理方式</p>
    <p>8.1 违约责任：发生如下情形之一的，视为您违约：</p>
    <p>8.1.1 使用平台服务时违反有关法律法规规定的；</p>
    <p>8.1.2 违反本协议约定的；</p>
    <p>8.1.3 我们获知的其他违约行为。</p>
    <p>8.2 违约处理：</p>
    <p>
      8.2.1
      如果我们发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，我们有权采取警示、限制参加营销活动、中止向您提供部分或全部服务、对相应信息采取删除、屏蔽处理或对您的商品进行下架、监管、指示第三方支付公司对您的账户采取冻结、终止、中止、限制使用帐号等功能、解除或终止本协议，或提出损害赔偿等措施。
    </p>
    <p>
      8.2.2
      本协议终止后，除法律有明确规定外，我们无义务向您或您指定的第三方披露您账户中的任何信息。本协议终止后，我们仍享有下列权利：根据法律规定，继续保存您留存于平台的的各类信息；对于您过往的违约行为，仍可依据本协议向您追究违约责任。
    </p>
    <p>
      8.2.3
      如您的行为致使我们或平台所涉的第三方公司遭受损失，您应根据本协议履行赔偿责任，您须赔偿的因此遭受的损失（如有）包括：
    </p>
    <p>（1）支付的合理律师费、诉讼费、消除影响所支出的必要费用；</p>
    <p>
      （2）因行政处罚、司法判决、法定标准范围内的调解等对外支出的罚款、违约金或赔偿金；
    </p>
    <p>
      （3）商誉损失、合理预期利益损失（如消费者的流失、支出减少、消费频次降低及店铺经营者收入减少等），具体金额可以第三方独立合理分析、平台根据大数据合理分析及其他计算收益、损失的合理方法所得出的相关估算标准作为计算依据；
    </p>
    <p>（4）因此遭受的其他损失。</p>
    <p>
      8.2.4
      如您的行为使得我们或平台所涉第三方公司遭受第三人主张权利，我们有权在承担相应给付等义务之后就全部损失向您追偿；如因您的行为使得第三人遭受损失或者您怠于履行调处决定，您同意我们指示第三方支付公司（通联支付）自您的账户中划扣相应款项支付上述赔偿款项。如您的账户中的款项不足以支付上述赔偿款项的，我们可直接抵减您在我们公司所签署的其它协议项下的权益，并可继续追偿。
    </p>
    <p>九、通知</p>
    <p>
      9.1
      您在注册成为平台用户并接受平台服务时，您应提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。
    </p>
    <p>
      9.2
      我们将向您提供的联系方式送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。
    </p>
    <p>9.3 通知的送达：</p>
    <p>
      9.3.1
      平台通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。
    </p>
    <p>
      9.3.2
      对于在平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在平台注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。
    </p>
    <p>
      9.3.3
      您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
    </p>
    <p>十、协议变更</p>
    <p>
      10.1
      我们有权遵照法律法规规定，在必要时修改本协议（包括适时制定并发布其他政策、规则、公告声明），更新后的协议条款将代替原来的协议并在法律规定的期限届满后正式生效，您可以在相关页面查阅最新版本的协议条款。本协议修改后，如果您继续使用本平台服务的，即视为您已接受修改后的协议。如果您不接受修改后的协议，则您有权利停止使用平台服务。
    </p>
    <p>十一、协议的终止、解除</p>
    <p>11.1【用户发起的终止】您有权通过以下任一方式终止本协议：</p>
    <p>11.1.1 变更事项生效前，您停止使用本平台服务；</p>
    <p>11.1.2 您明示不愿继续使用本平台服务。</p>
    <p>
      11.2【平台发起的终止、解除】如您存在下列情况之一的，我们有权终止、解除本协议，且不承担任何责任：
    </p>
    <p>
      11.2.1
      盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为；
    </p>
    <p>11.2.2 多次违反本协议约定或平台规则，情节严重的；</p>
    <p>
      11.2.3
      存在欺诈、发布或销售假冒伪劣、侵权商品、侵犯他人合法权益或其他严重违法违约行为。
    </p>
    <p>11.2.4 其他应当终止服务或解除本协议的情形。</p>
    <p>11.3 本协议终止、解除后，我们仍享有下列权利：</p>
    <p>11.3.1 继续保留您留存在本平台所列的各类信息；</p>
    <p>11.3.2 对于您过往的违约行为，我们认可依据本协议约定向您追究违约责任。</p>
    <p>十二、法律适用及争议解决方式</p>
    <p>12.1 本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律。</p>
    <p>
      12.2
      如双方就本本服务协议内容或其履行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向协议签订地，即东莞万饰网络科技有限公司住所地所在人民法院提起诉讼。
    </p>
  </div></template
>

<script>
export default {
  name: "xieyi"
};
</script>

<style scoped lang="less">
.xieyi {
  color: #333;
  padding: 30px;
  background: #f8faff;

  h2 {
    font-size: 34px;
    text-align: center;
  }

  p {
    font-size: 24px;
    margin-top: 20px;
    text-indent: 2em;
    line-height: 46px;
  }
}
</style>
